export default import.meta.ROLLDOWN_FILE_URL_taROLrGlP4I77buyhrbQxQ